var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 315,
    viewBox: "0 0 400 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.27918e-8,
    y1: 314.348,
    x2: 400,
    y2: 314.348,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.0608e-8,
    y1: 284.348,
    x2: 400,
    y2: 284.348,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.05993e-8,
    y1: 254.348,
    x2: 400,
    y2: 254.348,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.05993e-8,
    y1: 224.348,
    x2: 400,
    y2: 224.348,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.85688e-8,
    y1: 194.348,
    x2: 400,
    y2: 194.348,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.05993e-8,
    y1: 164.348,
    x2: 400,
    y2: 164.348,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.0608e-8,
    y1: 134.348,
    x2: 400,
    y2: 134.348,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.0608e-8,
    y1: 104.348,
    x2: 400,
    y2: 104.348,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.87671e-8,
    y1: 74.3477,
    x2: 400,
    y2: 74.3477,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.0608e-8,
    y1: 44.3477,
    x2: 400,
    y2: 44.3477,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.0608e-8,
    y1: 14.3477,
    x2: 400,
    y2: 14.3477,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.652,
    y1: -40,
    x2: 155.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.652,
    y1: -40,
    x2: 186.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.652,
    y1: -40,
    x2: 217.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.652,
    y1: -40,
    x2: 248.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.652,
    y1: -40,
    x2: 279.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.652,
    y1: -40,
    x2: 310.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.652,
    y1: -40,
    x2: 341.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.652,
    y1: -40,
    x2: 372.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.6523,
    y1: -40,
    x2: 31.6523,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.652299,
    y1: -40,
    x2: 0.652282,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.6523,
    y1: -40,
    x2: 62.6523,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.6523,
    y1: -40,
    x2: 93.6523,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.652,
    y1: -40,
    x2: 124.652,
    y2: 342,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.652,
    y1: -12.9371,
    x2: 399.652,
    y2: 314.938,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.3046
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsGrid);
export default __webpack_public_path__ + "static/media/skillsGrid.efdd9b20656bc73f9aa8ef931eed0ba9.svg";
export { ForwardRef as ReactComponent };